import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/sections/services/search-visibility/technical-seo/TechnicalSEOCTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/sections/services/search-visibility/technical-seo/TechnicalSEOHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/sections/services/search-visibility/technical-seo/TechnicalSEOProcess.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/sections/services/search-visibility/technical-seo/TechnicalSEOWhatIs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/sections/services/search-visibility/technical-seo/TechnicalSEOWhenNeeded.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/sections/services/search-visibility/technical-seo/TechnicalSEOWorkOn.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
